import { GA4Event } from "./GA4Event";

export {
	buildViewItemListEvent
}

/**
 * Baut ein einzelnes Event für "view_item_list" zusammen
 * https://developers.google.com/analytics/devguides/collection/protocol/ga4/reference/events#view_item_list
 *
 * @param {object} message - Daten für eine Produktliste mit sämtlichen Produktimpressionen
 *
 * @returns {object}
 */
function buildViewItemListEvent(message) {
	const { item_list_id, item_list_name, items } = message.params;
	const event = new GA4Event("view_item_list", {
		item_list_id,
		item_list_name
	});
	const eventData = event.build();
	const eventItems = [];
	for (const item of items) {
		const data = event.buildItem(item, true);
		eventItems.push(data);
	}
	eventData.params.items = eventItems;
	return eventData;
}
